import React from "react";
import Section1 from "./sections/Section1.healthy-back.tsx";
import Section3 from "./sections/Section3.healthy-back.tsx";
import Section4 from "./sections/Section4.healthy-back.tsx";
import Section5 from "./sections/Section5.healthy-back.tsx";
import Section6 from "./sections/Section6.healthy-back.tsx";
import Section7 from "./sections/Section7.healthy-back.tsx";

const HealthyBackHomepage: React.FC = () => {
  return (
    <>
      <Section1 /> {/* Section 2 is included here */}
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
       <Section7 />
    </>
  );
};

export default HealthyBackHomepage;
